// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEARCH_IN_FORUM = "Hledat v diskuz\u00edch na kon\u00edku...";
